// Cloudflare Turnstile (https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/)
// Token diminta hanya apabila site key dikonfigurasi; setiap token sekali guna.

import { session } from './api.js';
import { t, getLocale } from './i18n.js';

let loader = null;
function load() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!loader) {
    loader = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = () => resolve(window.turnstile);
      s.onerror = () => { loader = null; reject(new Error(t('turnstile.load_failed'))); };
      document.head.appendChild(s);
    });
  }
  return loader;
}

export async function turnstileToken() {
  const sitekey = session.config?.turnstile_site_key;
  if (!sitekey) return undefined;
  const ts = await load();
  let host = document.getElementById('ts-host');
  if (!host) {
    host = document.createElement('div');
    host.id = 'ts-host';
    host.style.cssText = 'position:fixed;bottom:90px;right:16px;z-index:70';
    document.body.appendChild(host);
  }
  return new Promise((resolve, reject) => {
    const id = ts.render(host, {
      sitekey,
      appearance: 'interaction-only',
      language: getLocale(),
      callback: (token) => { resolve(token); setTimeout(() => ts.remove(id), 0); },
      'error-callback': () => { reject(new Error(t('turnstile.failed'))); ts.remove(id); },
    });
  });
}
